import React from 'react';
import './LoadingSpinner.css';

export const LoadingSpinner = ({ 
    size = 'medium', 
    overlay = false,
    fullscreen = false,
    light = false,
    message = '',
    progress = null,
    showProgress = false,
    inline = false,
}) => {
    const spinnerClasses = [
        'loading-spinner',
        `spinner-${size}`,
        light ? 'spinner-light' : '',
        progress !== null ? 'with-progress' : ''
    ].filter(Boolean).join(' ');

    const containerClasses = [
        'spinner-container',
        inline ? 'inline' : '',
        overlay ? 'with-overlay' : '',
        fullscreen ? 'fullscreen' : '',
        message ? 'with-message' : '',
    ].filter(Boolean).join(' ');

    const messageClasses = [
        'spinner-message',
        inline ? 'inline' : '',
    ].filter(Boolean).join(' ');

    return (
        <div className={containerClasses}>
            <div className={`spinner-content ${inline ? 'inline' : ''}`}>
                <div className={spinnerClasses}></div>
                {message && (
                    <div className={messageClasses}>
                        {message}
                    </div>
                )}
                {showProgress && progress !== null && (
                    <div className="spinner-progress">
                        <div className="progress-bar">
                            <div 
                                className="progress-fill"
                                style={{ width: `${progress}%` }}
                            />
                        </div>
                        <div className="progress-text">{Math.round(progress)}%</div>
                    </div>
                )}
            </div>
            
        </div>
    );
}; 